import { render } from "./statistics.vue?vue&type=template&id=52e48c82&scoped=true&ts=true"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"

import "./statistics.vue?vue&type=style&index=0&id=52e48c82&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e48c82"]])

export default __exports__